export default __webpack_public_path__ + "static/media/profile3.79d53ccf.jpg";